module.exports = __webpack_public_path__ + "img/overheads-office-supplies.eff12665.svg";